import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsNumericalRelayIP, MultiOptDetails_2DS, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-numerical-relay',
  templateUrl: './ds-numerical-relay.component.html',
  styleUrls: ['./ds-numerical-relay.component.css']
})
export class DsNumericalRelayComponent implements OnInit, OnChanges {

  @Input() dsNumericalRelayObj: DsNumericalRelayIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsNumericalRelayObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewTransReqBlock() {
    this.dsNumericalRelayObj.addTransReqDS(new MultiOptDetails_2DS("", ""));
  }
  removeTransReqBlock(_dataDS: MultiOptDetails_2DS) {
    if (_dataDS) {
      this.dsNumericalRelayObj.removeTransReqDS(_dataDS);
    }
  }
  cachedRelCommProtocol: any = {};
  filterRelCommProtocol() {
    let _id = this.dsNumericalRelayObj.numRelayMake;
    if (this.cachedRelCommProtocol[_id] != null) {
      return this.cachedRelCommProtocol[_id];
    }
    this.cachedRelCommProtocol[_id] = this._dataService.numRelCommPrtcl.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedRelCommProtocol[_id];
    if (this.cachedRelCommProtocol[_id] != null) {
      return this.cachedRelCommProtocol[_id];
    }
    var _result = !this._dataService.isGeneralNumRelCommPrtcl(_id);
    this.cachedRelCommProtocol[_id] = _result;
    return _result;
  }

  cachedRelComm: any = {};
  filterRelComm() {
    let _id = this.dsNumericalRelayObj.relayCommProtcl;
    if (this.cachedRelComm[_id] != null) {
      return this.cachedRelComm[_id];
    }
    this.cachedRelComm[_id] = this._dataService.numRelCommPort.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedRelComm[_id];
    if (this.cachedRelComm[_id] != null) {
      return this.cachedRelComm[_id];
    }
    var _result = !this._dataService.isGeneralNumRelCommPort(_id);
    this.cachedRelComm[_id] = _result;
    return _result;
  }
  relCommChange() {
    this.dsNumericalRelayObj.parentDSRef.dsEthernetSwitchesIP.ethSwCommArch = '';
    this.dsNumericalRelayObj.parentDSRef.dsEthernetSwitchesIP.ethSwConfPopup = '';
  }

  transReqRTDChange(_td: MultiOptDetails_2DS) {
      _td.type2 = "";
  }
   sectionNoteChangePM(_event: any) {
    this.dsNumericalRelayObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsNumericalRelayObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsNumericalRelayObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];
    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Main Protection Relays", !!this.dsNumericalRelayObj.mainProtRelay, " required to save Datasheet.")
      );
      if (this.dsNumericalRelayObj.mainProtRelay_Enable) {
        _validList.push(
          new ValidationItem("Make", !!this.dsNumericalRelayObj.numRelayMake, " required to save Datasheet."),
          new ValidationItem("Type", !!this.dsNumericalRelayObj.numRelayType, " required to save Datasheet."),
          new ValidationItem("Relay Communication Protocol", !!this.dsNumericalRelayObj.relayCommProtcl, " required to save Datasheet."),
          new ValidationItem("Relay Communication Port", !!this.dsNumericalRelayObj.relayCommPort, " required to save Datasheet."),
          new ValidationItem("Time Sync. Protocol", !!this.dsNumericalRelayObj.timeSyncProtCl, " required to save Datasheet."),
          new ValidationItem("Coating", !!this.dsNumericalRelayObj.numRelayCoating, " required to save Datasheet."),
          new ValidationItem("Arc Protection", !!this.dsNumericalRelayObj.numRelayArcProtc, " required to save Datasheet.")
        );
        if (this.dsNumericalRelayObj.isNumRelayMakeApplicable) {
          _validList.push(new ValidationItem("Make Detail", !!this.dsNumericalRelayObj.numRelayMakeDetail, " required to save Datasheet."));
          if (this.dsNumericalRelayObj.isNumRelayMakeDetailApplicable) {
            _validList.push(new ValidationItem("Make Detail Other", !!this.dsNumericalRelayObj.numRelayMakeDetailOther, " required to save Datasheet."));
          }
        }
        // this.dsNumericalRelayObj.transducerReqRTD.forEach((_td, i) => {
        //   _validList.push(
        //     new ValidationItem("Transducer RTD " + (i + 1), !!_td.type1, " required to save Datasheet."),
        //     new ValidationItem("Transducer RTD Details " + (i + 1), !!_td.type2, " required to save Datasheet.")
        //   );
        // });
      }
      _validList.push(new ValidationItem("EE Note", !!this.dsNumericalRelayObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsNumericalRelayObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsNumericalRelayObj.sectionNoteME, " required to save Datasheet."));
    }
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsNumericalRelayObj.mainProtRelay || !this.dsNumericalRelayObj.sectionNoteEE) return false;
      if (this.dsNumericalRelayObj.mainProtRelay_Enable) {
        if (!this.dsNumericalRelayObj.numRelayMake || !this.dsNumericalRelayObj.numRelayType ||
          !this.dsNumericalRelayObj.relayCommProtcl || !this.dsNumericalRelayObj.relayCommPort ||
          !this.dsNumericalRelayObj.timeSyncProtCl || !this.dsNumericalRelayObj.numRelayCoating ||
          !this.dsNumericalRelayObj.numRelayArcProtc) {
          return false;
        }
        if (this.dsNumericalRelayObj.isNumRelayMakeApplicable && !this.dsNumericalRelayObj.numRelayMakeDetail) return false;
        if (this.dsNumericalRelayObj.isNumRelayMakeDetailApplicable && !this.dsNumericalRelayObj.numRelayMakeDetailOther) return false;
        // for (let _td of this.dsNumericalRelayObj.transducerReqRTD) {
        //   if (!_td.type1 || !_td.type2) return false;
        // }
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsNumericalRelayObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsNumericalRelayObj.sectionNoteME) return false;
    }
    return true;
  }
}

